export default __webpack_public_path__ + "static/client-video-embed-placeholder-7ee4f22d40cf4c756774f1a894761edd.png";